/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface IListSectionScope extends IBaseFieldSectionScope {
        model: ListSectionModel;
        field: Wars.Domain.Model.Field;
        isReadOnly: boolean;
        fieldBlurred: any;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        getDocumentDisplayString: (docId: string) => string;
        userActionInitiated: (u: any) => void;
    }

    export class ListSection implements IDirective {
        public link($scope: IFieldSectionScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = './app/views/directives/inputForm/listSection.html';
        public restrict: string = 'E';
        public controller = [
            '$scope', '$rootScope', 'ModalService', 'formSectionService', 'formService', 'formDataService', 'deleteService',
            'processService', "processDocumentService",'gisMapService', MultiAddSectionController ];
        public controllerAs = 'controller';
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            showSlider: "=",
            field: "=",
            formSection: "=",
            process: "=",
            isReadOnly: "=",
            fieldBlurred: "=",
            processConfigurationId: "=",
            processConfiguration: "=",
            formData: "=",
            formDataId: "=",
            formId: "=",
            form: "=",
            processId: "=",
            step: "="
        };
    }

    export class ListSectionModel extends FieldBaseModel {
        public isEditing: boolean;
        public editRow: any;
        public isEditRowReadOnly: boolean;

        constructor($scope: IListSectionScope,
            private $rootScope: angular.IRootScopeService,
            modalService: any,
            formSectionService: services.FormSectionService,
            formService: services.FormService,
            private formDataService: services.FormDataService,
            deleteService: services.DeleteService,
            processService: services.ProcessService,
            private processDocumentService: services.ProcessDocumentService,
            private gisMapService:services.GisMapService)
        {
            super($scope, modalService, formSectionService, formService, deleteService);
            $scope.userActionInitiated = (u) => this.userActionInitiated(u);
        }

        private userActionInitiated(userAction: Wars.Domain.Model.Dtos.UserActionModelDto) {
            this.$rootScope.$broadcast('userActionInitated', userAction);
        }

        public zoomToFeature(featureId:string) {
            this.gisMapService.zoomToFeature(featureId,this.$scope.process);
        }

        public selectRow(row) {
            this.isEditing = true;
            this.editRow = row;
            this.isEditRowReadOnly = false;

            if (this.$scope.process && this.$scope.process.metadata[row.id]) {
                try {
                    let metadataObj = JSON.parse(this.$scope.process.metadata[row.id]);

                    if (metadataObj.onlyAllowApiEdits) {
                        this.isEditRowReadOnly = true;
                    }
                } catch (error) {
                    services.WarsLogger.logWarn("Error Parsing JSON for metadata: " + error, "ListSection");
                }
            }
        }

        public addListItem(formSection: Wars.Domain.Model.FormSection) {
            if (!this.$scope.formData) {
                return;
            }
            if (this.$scope.formData[formSection.objectSchema.uniqueIdentifier] == null) {
                this.$scope.formData[formSection.objectSchema.uniqueIdentifier] = [];
            }

            var newItem = { id: services.UtilityService.generateGuidComb() };
            this.formDataService.addListRow(this.$scope.process.id,
                this.$scope.formId,
                this.$scope.formDataId,
                formSection.objectSchema.uniqueIdentifier,
                newItem.id);

            

            this.$scope.formData[formSection.objectSchema.uniqueIdentifier].push(newItem);
            this.isEditing = true;
            this.editRow = <any>newItem;

            this.$scope.process.processNames[this.editRow.id] = null;
        }

        public removeRow(row, formSection) {
            this.isEditing = false;
            this.formDataService.removeListRow(this.$scope.process.id,
                this.$scope.formId,
                this.$scope.formDataId,
                formSection.objectSchema.uniqueIdentifier,
                (<any>this.editRow).id).then((result) => {
                if (result && result.data.docIdsRemoved != null) {
                    this.processDocumentService.updateProcessDocuments(this.$scope.process, [], result.data.docIdsRemoved);
                }
                if (result && result.data.featuresRemoved != null) {
                    result.data.featuresRemoved.forEach(f => {
                        this.gisMapService.removeFeature(f,this.$scope.process);
                    });
                }
            });

            this.$scope.formData[formSection.objectSchema.uniqueIdentifier].remove(this.editRow);
            this.editRow = null;
        }
    }

    export class MultiAddSectionController implements IController {
        constructor(
            private $scope: IListSectionScope,
            private $rootScope: angular.IRootScopeService,
            private modalService: any,
            private formSectionService: services.FormSectionService,
            private formService: services.FormService,
            formDataService: services.FormDataService,
            deleteService: services.DeleteService,
            processService: services.ProcessService,
            private processDocumentService: services.ProcessDocumentService,
            private gisMapService:services.GisMapService)
        {
            $scope.model = new ListSectionModel($scope,
                $rootScope,
                modalService,
                formSectionService,
                formService,
                formDataService,
                deleteService,
                processService,
                processDocumentService,
                gisMapService);

            $scope.getDocumentDisplayString = (docId: string) => this.getDocumentDisplayString(docId);
        }

        private getDocumentDisplayString(docId: string): string {
            if (docId) {
                const document = this.processDocumentService.getDocumentById(this.$scope.process, docId);
                if (document) {
                    return document.fileName;
                }
            }
            return "";
        }
    }
}

warsApp.registerDirective('ListSection', []);